/**
 * GitLab's OAuth redirect lands as `https://host/?code=...&state=...` with
 * an EMPTY hash. A bare `createWebHashHistory()` router never matches any
 * route on that first load, regardless of the exact registered
 * `redirect_uri` shape (Story 013.1). This pure function detects that case
 * so `main.ts` can redirect into the hash-routed `/callback` path before
 * mounting.
 */
export function resolveHashBootstrapRedirect(
  location: Pick<Location, 'search' | 'hash'>,
): string | null {
  if (location.hash) return null;
  if (!new URLSearchParams(location.search).has('code')) return null;
  return `/callback${location.search}`;
}
